import React from "react";
import { HorizontalLogo } from "../Brand/HorizontalLogo";

export const HeaderLogo = () => {
  return <HorizontalLogo />;
};
